import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../common/selectCustom'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { SELECT_FIELD } from '../constants'
import {
  selectListFieldRequest,
  selectListSelectionRequest,
  setListFieldRequest,
} from '../store/slice'
import { getAutoFilledVal, getRemainingFieldSelection } from './helper'

export const FieldSelection = ({ item, index, userProfile }) => {
  const dispatch = useDispatch()

  const listFieldRequest = useSelector(selectListFieldRequest)
  const listSelection = useSelector(selectListSelectionRequest)

  const handleSelectField = (item, index) => {
    const newListFieldRequest = listFieldRequest.map((obj, ind) => {
      if (index === ind) {
        return {
          ...item,
          value: item.value,
          inputValue: getAutoFilledVal(userProfile, item.value),
        }
      }

      return obj
    })
    dispatch(setListFieldRequest(newListFieldRequest))
  }

  return (
    <SelectCustom
      zIndex={13}
      renderActiveItem={() => {
        return (
          <div>
            <TextEllipsisStaticLine
              text={item?.label}
              lineClamp={1}
              zIndexTooltip={15}
            />
          </div>
        )
      }}
      chooseItem={(item) => handleSelectField(item, index)}
      data={getRemainingFieldSelection(
        index,
        listFieldRequest,
        listSelection,
      ).filter((item) => item?.value)}
      isI18n
      style={{
        backgroundColor: '#FFFFFF',
        minWidth: 160,
        height: 28,
        maxWidth: 160,
      }}
      styleDropdown={{ backgroundColor: '#FFFFFF', width: 160 }}
      disabled={
        index < listFieldRequest.length - 1 && item.label !== SELECT_FIELD.label
      }
    />
  )
}
